import type { AnchorHTMLAttributes, ReactNode } from 'react';

type SiteLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
    to: string;
    children: ReactNode;
};

export const SiteLink = ({ to, children, ...props }: SiteLinkProps) => <a href={to} {...props}>{children}</a>;
